/* eslint-disable */

import Multiselect from 'vue-multiselect'
import Vue from 'vue'
import { mapGetters } from "vuex";
import readXlsxFile from 'read-excel-file'
import toast from '@/services/toast';

var $ = window.jQuery = require('jquery');
Vue.component('multiselect', Multiselect)
export default {
  name: 'global-all-user-mail',
  components: {
    Multiselect
  },
  props: [],
  data () {
    return {
      selectUser:'',
      users:[],
      subject:'',
      message:`<table width="100%" border="0" cellspacing="0" cellpadding="0" cellpadding="0" align="center" background="#fff1e5"
      style="background:#fff1e5;border:0px;color: #000000;">
      <style>
        a{color:#000000;text-decoration:none;}
      </style>
      <tbody>
        <tr>
          <td background="https://oddvega-public-content.s3.ca-central-1.amazonaws.com/useradmin_bg.58c6da5d.jpg"
            valign="top"
            style="background-image: url(https://oddvega-public-content.s3.ca-central-1.amazonaws.com/useradmin_bg.58c6da5d.jpg);background-position: top center;background-repeat: no-repeat;background-size:cover;background-attachment:fixed;border:0px;padding: 20px;color: inherit;">
            <div style="color:#ffffff;text-align:center;">
              <table cellpadding="0" cellspacing="0" border="0" width="100%"
                background="https://oddvega-public-content.s3.ca-central-1.amazonaws.com/email_transparent_bg.png"
                style="text-align: left;margin-top:0px;background-image:url('https://oddvega-public-content.s3.ca-central-1.amazonaws.com/email_transparent_bg.png');border-radius: 3px;padding:0px;margin-left:auto;margin-right:auto;margin-top:0;margin-bottom:0;font-size:16px;max-width:650px;width:100%;box-sizing:border-box;line-height: 1.3;background-repeat:no-repeat;background-size:100% 100%;border:0px;color:inherit;text-align:left;">
                <tr>
                  <td style="border:0px;padding:15px;color: inherit;">
                    <table cellpadding="0" cellspacing="0" border="0" width="100%" style="border:0px;color: inherit;">
                      <tr>
                        <td height="50" align="center" style="border:0px;padding:15px 0 15px;"><img
                            src="https://oddvega-public-content.s3.ca-central-1.amazonaws.com/oddvega-logo-new.png"
                            width="150" height="" alt="" style="display:inline-block;border:0px;"></td>
                      </tr>
                      <tr>
                        <td style="color:inherit;border:0px;padding-bottom: 20px;font-size:15px;">
                          <h5 style="font-size: 20px;font-weight:600;margin: 0px;">Hi {{name}},</h5>
                        </td>
                      </tr>
                      <tr>
                        <td style="box-sizing:border-box;padding:0px;border:0px">
                          <table width="100%" border="0" cellspacing="0" cellpadding="0" cellpadding="0" align="center"
                            style="border:0px;">
                            <tr>
                              <td style="background:#000000;padding:10px 15px;border:0px;">
                                <table width="100%" border="0" cellspacing="0" cellpadding="0" cellpadding="0"
                                  align="center" style="border:0px;">
                                  <tr>
                                    <td
                                      style="text-align: center;margin: 0;box-sizing:border-box;border:0px;padding-top:0;padding-bottom:0;">
                                      <table border="0" cellspacing="0" cellpadding="0" cellpadding="0" align="center"
                                        style="border:0px;text-align:center;margin:0 auto;">
                                        <tr>
                                          <td
                                            style="box-sizing:border-box;border:0px;padding-left:3px;padding-right:3px;text-align: center;padding-top:0;padding-bottom:0;">
                                            <a href="https://www.oddvega.com/contact-us/" style="color:#ffffff;font-family:'Muli', Arial,sans-serif;font-size:14px;text-decoration:underline;display: inline-block;
    vertical-align: middle;">Contact Us</a>
                                          </td>
                                          <td
                                            style="box-sizing:border-box;border:0px;padding-left:3px;padding-right:3px;text-align: center;padding-top:0;padding-bottom:0;">
                                            <a href="https://www.oddvega.com/contact-us/" style="color:#ffffff;font-family:'Muli', Arial,sans-serif;font-size:14px;text-decoration:underline;display: inline-block;
    vertical-align: middle;">About Us</a>
                                          </td>
                                          <td
                                            style="box-sizing:border-box;border:0px;padding-left:3px;padding-right:3px;text-align: center;padding-top:0;padding-bottom:0;">
                                            <a href="javascript:void(0)" style="color:#ffffff;font-family:'Muli', Arial,sans-serif;font-size:14px;text-decoration:underline;display: inline-block;
    vertical-align: middle;">Terms of Use</a>
                                          </td>
                                          <td
                                            style="box-sizing:border-box;border:0px;padding-left:3px;padding-right:3px;text-align: center;padding-top:0;padding-bottom:0;">
                                            <a href="https://www.oddvega.com/privacy-policy/" style="color:#ffffff;font-family:'Muli', Arial,sans-serif;font-size:14px;text-decoration:underline;display: inline-block;
    vertical-align: middle;">Privacy Policy</a>
                                          </td>
                                        </tr>
                                      </table>
                                    </td>
                                  </tr>
                                  <tr>
                                    <td
                                      style="text-align:center;color:#ffffff;font-family:'Muli', Arial,sans-serif;font-size:14px;line-height:1;padding-top:6px;margin:0px;box-sizing:border-box; border:0px;padding-bottom:0px;">
                                      © Oddboot Technologies Inc. 2024
                                    </td>
                                  </tr>
                                </table>
                              </td>
                            </tr>
                          </table>
                        </td>
                      </tr>
                    </table>
                  </td>
                </tr>
              </table>
            </div>
          </td>
        </tr>
      </tbody>
    </table>`,
      userList:null,
      userListResults:[], 
      value: [],
      options: [],
      submitted:false,
      multiselect:false,
      config: {
        events: {
          initialized: function () {
            console.log('initialized')
          }
        }
      },
      confirmedSendMail:false,
      preview_box:false,
      UnsubscribedMultiple:false,
      unsubScribedmultiple:'',
      unsubScribedmultipleMail:[],
      unsubScribedmultiple_popup:false,
      excelImportDataList:[],
      reg: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/,
      readExcelFileLoader:false,
      confirmationDelieveredPopup:false,
      file:null,
      uploadAttachmentName:''
    }
  },
  computed: {
    ...mapGetters([
      'getuserListDetailsState'
    ]),
    getUserList() {
      this.userList = this.$store.getters.getuserListDetailsState.data
      return
    },
    setIntialsState(){
      if(this.userList){
        this.userListResults = this.userList.results
        for(var i = 0; i < this.userListResults.length; i++){
          this.options.push({first_name:this.userListResults[i].first_name,last_name:this.userListResults[i].last_name,email:this.userListResults[i].email, id : this.userListResults[i].id})
        }
      }
      return
    }
  },
  created() {
  },
  mounted () {
    this.getUserList
    this.setIntialsStated
    this.createEditor();
  },
  methods: {
    clearUploadedFileMethod(){
      this.file = null
      this.uploadAttachmentName = ''
    },
    handleAttachmentUpload(event) {
      if(event.target.files && event.target.files.length > 0) {
        this.file = event.target.files[0];
        this.files = this.$refs.file.files[0];
        this.uploadAttachmentName = this.files.name
      }else {
        this.uploadAttachmentName = '';
      }
    },
    confirmationDelieveredPopupClose(){
      this.confirmationDelieveredPopup = false
      $('body').removeClass('body_right_scroll_remove')
    },
    createEditor() {
      CKEDITOR.replace('message',{
        height:350,
        allowedContent:true,
        onLoad: function() {
          CKEDITOR.addCss(
              'a{' +
                  'color: #ffffff' +
               '}'
          );
      }
      });
      CKEDITOR.instances['message'].on('change', () => {
        var content1Length = CKEDITOR.instances['message'].getData().replace(/<[^>]*>/gi, '').length;
        if(content1Length > 0){
          this.message = CKEDITOR.instances['message'].getData()
        }else{
          this.message = ''
        }
      })
    },
    onChange(value) {
      if(this.selectUser == 'Select Multiple'){
        this.multiselect = true
        this.UnsubscribedMultiple = false
        this.unsubScribedmultipleMail = []
        this.excelImportDataList = []
      }else if(this.selectUser == 'Unsubscribed Multiple'){
        this.multiselect = false
        this.UnsubscribedMultiple = true
        this.value = ''
      }else{
        this.multiselect = false
        this.UnsubscribedMultiple = false
        this.value = ''
        this.unsubScribedmultipleMail = []
        this.excelImportDataList = []
      }
    },
    validateCreateMailBeforeSubmit(){
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.confirmedSendMail = true
          $('body').addClass('email_sent_popup')
        }
      });
    },
    addTag (newTag) {
      const tag = {
        name: newTag,
        code: newTag.substring(0, 2) + Math.floor((Math.random() * 10000000))
      }
      this.options.push(tag)
      this.value.push(tag) 
    },
    customLabel ({ email, first_name, last_name }) {
      return `${first_name} ${last_name} - ${email}`
    },
    yesConfirmed(){
      this.submitted = true;
      if(this.selectUser == 'Select Multiple'){
        for(var i = 0; i < this.value.length; i++){
          this.users.push(this.value[i].id)
        }
        let formData = new FormData();
        formData.append('subject', this.subject);
        formData.append('message', this.message);
        formData.append('type', 'email');
        formData.append('users', JSON.stringify(this.users));
        if(this.file){
          formData.append('file_attachment', this.file);
        }
        this.$store.dispatch('selectedUsersMailSendAction', formData).then((res) => {
          toast.success(res.data.msg);
          $('body').removeClass('email_sent_popup')
          this.submitted = false;
          this.confirmedSendMail = false
          this.subject = ''
          this.users = []
          this.value = []
          this.clearUploadedFileMethod()
          this.$validator.reset();
          this.confirmationDelieveredPopup = true
          $('body').addClass('body_right_scroll_remove')
        }).catch((err) => {})
      }else if(this.selectUser == 'Unsubscribed Multiple'){
        let formData = new FormData();
        formData.append('subject', this.subject);
        formData.append('message', this.message);
        formData.append('type', 'email');
        if(this.file){
          formData.append('file_attachment', this.file);
        }
        if(this.excelImportDataList.length > 0){
          let userArr = []
          Object.keys(this.excelImportDataList).map((index) => {
            if(this.isEmailValid(this.excelImportDataList[index][0]) == true){
              userArr.push(this.excelImportDataList[index][0])
            }
          });
          formData.append('users',  JSON.stringify(userArr));
        }
        if(this.unsubScribedmultipleMail.length > 0){
          formData.append('users',  JSON.stringify(this.unsubScribedmultipleMail));
        }
        this.$store.dispatch('selectedExelUsersMailSendAction', formData).then((res) => {
          toast.success(res.data.msg);
          $('body').removeClass('email_sent_popup')
          this.submitted = false;
          this.confirmedSendMail = false
          this.subject = ''
          this.unsubScribedmultipleMail = []
          this.excelImportDataList = []
          this.clearUploadedFileMethod()
          this.$validator.reset();
          this.confirmationDelieveredPopup = true
          $('body').addClass('body_right_scroll_remove')
        }).catch((err) => {})
      }else if(this.selectUser == 'Testing'){
        let formData = new FormData();
        formData.append('subject', this.subject);
        formData.append('type', 'email');
        formData.append('message', this.message);
        if(this.file){
          formData.append('file_attachment', this.file);
        }
        this.$store.dispatch('staffUserMailForTestingFun', formData).then((res) => {
          toast.success(res.data.msg);
          $('body').removeClass('email_sent_popup')
          this.clearUploadedFileMethod()
          this.submitted = false;
          this.confirmedSendMail = false
          this.subject = ''
          this.$validator.reset();
          this.confirmationDelieveredPopup = true
          $('body').addClass('body_right_scroll_remove')
        }).catch((err) => {})
      }else{
        let formData = new FormData();
        formData.append('subject', this.subject);
        formData.append('type', 'email');
        formData.append('message', this.message);
        if(this.file){
          formData.append('file_attachment', this.file);
        }
        this.$store.dispatch('selectedAllUsersMailSendAction', formData).then((res) => {
          toast.success(res.data.msg);
          $('body').removeClass('email_sent_popup')
          this.clearUploadedFileMethod()
          this.submitted = false;
          this.confirmedSendMail = false
          this.subject = ''
          this.$validator.reset();
          this.confirmationDelieveredPopup = true
          $('body').addClass('body_right_scroll_remove')
        }).catch((err) => {})
      }
      return;
    },
    cancleConfirmed(){
      $('body').removeClass('email_sent_popup')
      this.submitted = false;
      this.confirmedSendMail = false
    },
    previewBtn(){
      this.preview_box = true
      $('body').addClass('email_sent_popup')
      setTimeout(()=>{
        if(this.typeOfSelection == 'mobile'){
          document.getElementById("mailcode").innerHTML = this.sms_msg;
        }else{
          document.getElementById("mailcode").innerHTML = this.message;
        }
      },200)
    },
    closePreviewBtn(){
      this.preview_box = false
      $('body').removeClass('email_sent_popup')
    },
    unsubScribedmultipleMailPopupFun(){
      this.unsubScribedmultiple_popup = true
      $('body').addClass('email_sent_popup')
    },
    unsubScribedmultipleMailClosePopupFun(){
      this.unsubScribedmultiple_popup = false
      $('body').removeClass('email_sent_popup')
      document.getElementById("importEmail").value = null;
    },
    unsubScribedmultipleFun(e){
      this.unsubScribedmultipleMail.push(this.unsubScribedmultiple)
      this.unsubScribedmultiple = ''
      this.$validator.reset();
    },
    removeAttributes : function (index) {
      Vue.delete(this.unsubScribedmultipleMail, index);
    },
    handleExcelFileUpload(event) {
      this.readExcelFileLoader = true
      this.excelImportDataList = []
      readXlsxFile(event.target.files[0]).then((res) => {
        this.excelImportDataList = res
        this.readExcelFileLoader = false
        this.unsubScribedmultipleMailClosePopupFun()
      })
    },
    isEmailValid(email) {
      return this.reg.test(email);
    },
    removeImportAttributes (index) {
      Vue.delete(this.excelImportDataList, index);
      
    },
    removeImportAttributesInPopup (index) {
      Vue.delete(this.excelImportDataList, index);
      if(this.excelImportDataList.length == 1){document.getElementById("importEmail").value = null;}
      
    },
    addImportedEMailFun(e){
      this.unsubScribedmultipleMail.push(this.excelImportDataList)
      this.excelImportDataList = []
      document.getElementById("importEmail").value = null;
      this.$validator.reset();
    },
    removeImportedEMailFun(){
      this.excelImportDataList = []
      document.getElementById("importEmail").value = null;
    }
  },
  watch:{
    getUserList() {
      return this.$store.getters.getuserListDetailsState
    },
    userList(old_val, new_val){
      if(new_val == undefined){
        this.userListResults = old_val.results
        for(var i = 0; i < this.userListResults.length; i++){
          this.options.push({first_name:this.userListResults[i].first_name,last_name:this.userListResults[i].last_name,email:this.userListResults[i].email, id : this.userListResults[i].id})
        }
      }
    },
  }
}